import React from "react";

const WalletListIcon = ({ width, height, color }) => {
  return (
    <svg
      width="35"
      height="29"
      viewBox="0 0 35 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 11.8318C35 10.8783 34.227 10.1053 33.2735 10.1053H23.3856C22.4322 10.1053 21.6592 10.8783 21.6592 11.8318V17.0112C21.6592 17.9647 22.4322 18.7376 23.3856 18.7376H33.2735C34.227 18.7376 35 17.9647 35 17.0112V11.8318ZM26.6055 16.4567C25.494 16.4567 24.5929 15.5556 24.5929 14.4441C24.5929 13.3326 25.494 12.4315 26.6055 12.4315C27.717 12.4315 28.6181 13.3326 28.6181 14.4441C28.6181 15.5555 27.717 16.4567 26.6055 16.4567Z"
        fill="#00008B"
      />
      <path
        d="M19.3848 7.7511H32.1749V2.57173C32.1749 1.27359 31.1712 0.217468 29.8729 0.217468H2.40652C1.10839 0.217468 0 1.27359 0 2.57173V26.4282C0 27.7264 1.10839 28.7825 2.40652 28.7825H29.8729C31.171 28.7825 32.1749 27.7264 32.1749 26.4282V21.0919H19.4082L19.3848 7.7511Z"
        fill="#00008B"
      />
    </svg>
  );
};

export default WalletListIcon;
